import { ToastContextDispatch, UserInfoContext } from "Context/CommonContext";
import useMasterContext from "Context/MasterContext";
import MyUserManagenentFilter from "Pages/UserManagement/MyUserManagementFilter";
import MyUserManagementTable from "Pages/UserManagement/MyUserManagementTable";
import { getAPIRequest } from "utilFunctions/Axios/AxiosRequestConfiguration";
import { useContext, useEffect, useState } from "react";
import { Card } from "reactstrap";
import getRequestInterface from "utilFunctions/Axios/getRequestInterface";
import {
  BASE_URL,
  FETCH_REGION,
  GET_USER,
} from "utilFunctions/Constants/urlConstants";
import { EDPUserRoles, NADUserRoles } from "utilFunctions/Constants/Constants";
import {
  FilterObject,
  // filterArrayBasedOnObjectKeys,
  removeEmptyFields,
} from "utilFunctions/helperFunctions/HelperFunction";
import FEPagination from "utilFunctions/shared/FEPagination";
import { AllUserRoles, Status } from "utilFunctions/Constants/Constants";
import SliderPaneComponent from "Components/CommonComponents/SliderPaneComponent";
import { UsermManagementForm } from "Pages/UserManagement/UserManagementForm";
import styled from "styled-components";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import { pushToDataLayerForGTM } from "utilFunctions/helperFunctions/analytics";
// import { filter } from "lodash";
const DIVStyled = styled<any>("div")`
  padding: ${(props: any) =>
    ["lg", "xl", "xxl"].includes(props.screen)
      ? "20px 20px 20px 48px"
      : "16px"};
`;
const SORT_ASC = "ASC";

const MyUserManagement = () => {
  const { screen }: any = useWindowSize();
  const fetchUrl = BASE_URL + GET_USER;
  const { masters } = useMasterContext();
  const userInfo = useContext<any>(UserInfoContext);
  const [data, setData] = useState<any[]>([]);
  const [region, setRegion] = useState<any>();
  // const [department, setDepartment] = useState<any>();
  const [previousData, setPreviousData] = useState<any[]>([]);
  const ToastDispatch = useContext<any>(ToastContextDispatch);
  const [currentPage, setCurrentPage] = useState(1);
  const [filterDataValue, setFilterDataValue] = useState<any>();
  const [sortOrder, setSortOrder] = useState(SORT_ASC);
  const [sortColumn, setSortColumn] = useState<any>("name");
  const [filterData, setFilterData] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);
  const [isOpenForm, setIsOpenForm] = useState<boolean>(false);
  const [selectedUser, setSelectedUser] = useState<any>(null);
  // const [limit] = useState<number>(500);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [pageLimitValue, setPageLimitValue] = useState<any>([
    { label: "10", value: 10 },
  ]);
  const [userAssignedRegion, setUserAssignedRegion] = useState<any>([]);
  const [refresh, setRefresh] = useState<any>(false);
  const [totalItems, setTotalLimits] = useState<any>("");
  const [formLoading, setFormLoading] = useState<boolean>(false);
  const [pageLimits] = useState([
    {
      label: "10",
      value: 10,
    },
    {
      label: "20",
      value: 20,
    },
    {
      label: "50",
      value: 50,
    },
  ]);

  const UserRoles =
    userInfo?.fexRole == "National Head"
      ? AllUserRoles
      : userInfo?.fexRole == "NAD Team"
      ? NADUserRoles
      : userInfo?.fexRole == "Branch EDP"
      ? EDPUserRoles
      : [{ value: null, label: "Select" }];

  useEffect(() => {
    pushToDataLayerForGTM({
      event: "ag_user_management_view_user_management",
      USER_ROLE: userInfo?.fexRole,
    });
  }, []);
  const handlePageChange = (page: any) => {
    setCurrentPage(page);
  };

  // const indexOfLastItem = currentPage * itemsPerPage;
  // const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  // const currentData = data.slice(indexOfFirstItem, indexOfLastItem);
  useEffect(() => {
    console.log(sortColumn, "sortColumn", sortOrder);
    if (
      ["National Head", "NAD Team", "Branch EDP"].includes(userInfo?.fexRole)
    ) {
      let newUrl =
        fetchUrl +
        "?sort_by=" +
        sortColumn +
        "&sortDir=" +
        sortOrder +
        "&items_per_page=" +
        itemsPerPage +
        "&page=" +
        currentPage;
      // newUrl = newUrl + `&branch=${userInfo?.branch}`;
      const filters = [];
      const formValues: any = filterData;
      for (const key in formValues) {
        if (Object.prototype.hasOwnProperty.call(formValues, key)) {
          if (formValues[key] !== null && formValues[key] !== "") {
            filters.push(
              encodeURIComponent(key) +
                "=" +
                encodeURIComponent(formValues[key])
            );
          }
        }
      }
      if (Array.isArray(filters) && filters.length > 0) {
        newUrl = newUrl + "&" + filters.join("&");
      }
      fetchData(newUrl);
    }
  }, [
    userInfo,
    filterData,
    itemsPerPage,
    currentPage,
    refresh,
    sortColumn,
    sortOrder,
  ]);
  const clearAllHandler = () => {
    setData(previousData);
  };

  useEffect(() => {
    fetchregion(BASE_URL + FETCH_REGION);
  }, [userInfo]);
  // const fetchDepartment = async (url: any) => {
  //   await getAPIRequest({
  //     url: url,
  //     success: (response: any) => {
  //       const data = response?.data;
  //       if (data["data"].length > 0) {
  //         const department = data["data"].map((ele: any) => {
  //           return { label: ele.deptName, value: ele.id };
  //         });
  //         setDepartment(department);
  //       }
  //       setTimeout(() => {
  //         setLoading(false);
  //       }, 300);
  //     },
  //     failure: (err: any) => {
  //       ToastDispatch({
  //         isOpen: true,
  //         type: "Error",
  //         message: err?.message,
  //       });
  //       setData([]);
  //       setPreviousData([]);
  //       setTimeout(() => {
  //         setLoading(false);
  //       }, 300);
  //     },
  //   } as getRequestInterface);
  // };

  const fetchregion = async (url: any) => {
    await getAPIRequest({
      url: url,
      success: (response: any) => {
        const data = response?.data;
        if (data["data"] != undefined) {
          const regiondata: any = [];
          data["data"].map((item: any) => {
            regiondata.push({
              id: item.regionCode,
              label: item.region,
              value: item.id,
            });
          });
          setRegion(regiondata);
          if (userInfo?.region && userInfo?.region != null) {
            const userAssignedBranchArray = userInfo?.region
              .split(",")
              .map(Number);
            const filteredRegion = regiondata.filter((item: any) => {
              return userAssignedBranchArray.includes(item.value);
            });
            setUserAssignedRegion(filteredRegion);
          } else {
            setUserAssignedRegion([]);
          }
        }
        setTimeout(() => {
          setLoading(false);
        }, 300);
      },
      failure: (err: any) => {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: err?.message,
        });
        setTimeout(() => {
          setLoading(false);
        }, 300);
      },
    } as getRequestInterface);
  };
  useEffect(() => {
    const filters: FilterObject = removeEmptyFields(filterDataValue);
    // console.log("filterA", filters);
    // const filteredArray = filterArrayBasedOnObjectKeys(previousData, filters);
    setFilterData(filters);
    setCurrentPage(1);
    setItemsPerPage(10);
    setPageLimitValue([{ label: "10", value: 10 }]);
  }, [filterDataValue]);

  const fetchData = async (url: string) => {
    console.log("reponsedata", url);

    // url =
    //   url +
    //   "&subject=" +
    //   userInfo?.subjectsListing?.map((ele: any) => ele.key)?.toString() +
    //   "&stream=" +
    //   userInfo?.userStreams?.map((ele: any) => ele.key)?.toString();
    setLoading(true);
    await getAPIRequest({
      url: url,
      success: (response: any) => {
        const data = response?.data;
        if (data["data"].length > 0) {
          setPreviousData(data.data ? data.data : []);
          setData(data.data ? data.data : []);
          console.log("reponsedata", data?.data);

          setTotalLimits(data?.pagination?.totalCount);
        } else {
          setData([]);
          console.log("reponsedata", data?.data);

          setPreviousData([]);
        }
        setTimeout(() => {
          setLoading(false);
        }, 300);
      },
      failure: (err: any) => {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: err?.message,
        });
        setData([]);
        setPreviousData([]);
        setTimeout(() => {
          setLoading(false);
        }, 300);
      },
    } as getRequestInterface);
  };
  console.log(itemsPerPage, data, "checkpagin", userInfo);
  return (
    <DIVStyled screen={screen}>
      <Card className="libraryCardContainer">
        <MyUserManagenentFilter
          userInfo={userInfo}
          subjects={userInfo?.subjectsListing}
          stream={userInfo?.userStreams}
          branch={masters?.userAssignedBranches}
          status={Status}
          role={UserRoles}
          // department={department}
          filterDataValue={filterDataValue}
          setFilterDataValue={setFilterDataValue}
          clearAllHandler={clearAllHandler}
          region={userAssignedRegion}
          isOpenForm={isOpenForm}
          setIsOpenForm={setIsOpenForm}
        ></MyUserManagenentFilter>
        <MyUserManagementTable
          region={region}
          masters={masters}
          status={Status}
          userInfo={userInfo}
          loading={loading}
          data={data}
          sortColumn={sortColumn}
          setSortColumn={setSortColumn}
          sortOrder={sortOrder}
          setSortOrder={setSortOrder}
          setSelectedUser={setSelectedUser}
          setIsOpenForm={setIsOpenForm}
          setFormLoading={setFormLoading}
        ></MyUserManagementTable>
        {data.length > 0 && (
          <FEPagination
            pageLimitValue={pageLimitValue}
            setPageLimitValue={setPageLimitValue}
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            setCurrentPage={setCurrentPage}
            pageLimits={pageLimits}
            setItemsPerPage={setItemsPerPage}
          />
        )}
      </Card>
      <SliderPaneComponent
        width={"100%"}
        isPaneOpen={isOpenForm}
        hideHeader={true}
        onRequestClose={() => {
          setIsOpenForm(false);
          setSelectedUser(null);
          setFormLoading(false);
        }}
      >
        <UsermManagementForm
          formLoading={formLoading}
          region={region}
          selectedUser={selectedUser}
          UserRoles={UserRoles}
          setRefresh={setRefresh}
          onRequestClose={() => {
            setIsOpenForm(false);
            setSelectedUser(null);
          }}
        />
      </SliderPaneComponent>
    </DIVStyled>
  );
};
export default MyUserManagement;
